export const HTTP_OK = 200 as const;
export const HTTP_FORBIDDEN = 403 as const;
export const HTTP_UNPROCESSABLE_ENTITY = 422 as const;
